import React, { useState } from 'react';
import { supabaseClient } from '../utils/supabaseClient';

interface StoreSelectionModalProps {
  stores: { shopname: string }[];
  maxStores: number;
  onConfirm: (selectedStores: string[]) => void;
}

const StoreSelectionModal: React.FC<StoreSelectionModalProps> = ({
  stores,
  maxStores,
  onConfirm,
}) => {
  const [selectedStores, setSelectedStores] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);

  const handleStoreToggle = (shopname: string) => {
    setSelectedStores(prev => {
      if (prev.includes(shopname)) {
        return prev.filter(name => name !== shopname);
      } else {
        if (prev.length < maxStores) {
          return [...prev, shopname];
        } else {
          setError(`最大${maxStores}店舗までしか選択できません`);
          return prev;
        }
      }
    });
  };

  const handleConfirm = () => {
    if (selectedStores.length !== maxStores) {
      setError(`ちょうど${maxStores}店舗を選択してください`);
      return;
    }
    onConfirm(selectedStores);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="mb-4">
          <h2 className="text-xl font-semibold">店舗の選択</h2>
          <p className="text-sm text-gray-600 mt-2">
            新しいプランでは{maxStores}店舗までしか登録できません。
            保持したい店舗を選択してください。
          </p>
        </div>

        <div className="mb-4">
          <div className="max-h-60 overflow-y-auto">
            {stores.map((store) => (
              <div
                key={store.shopname}
                className="flex items-center space-x-2 p-2 hover:bg-gray-50"
              >
                <input
                  type="checkbox"
                  id={store.shopname}
                  checked={selectedStores.includes(store.shopname)}
                  onChange={() => handleStoreToggle(store.shopname)}
                  className="h-4 w-4 text-[#007AFF] focus:ring-[#007AFF] border-gray-300 rounded"
                />
                <label
                  htmlFor={store.shopname}
                  className="flex-1 text-sm text-gray-700 cursor-pointer"
                >
                  {store.shopname}
                </label>
              </div>
            ))}
          </div>
        </div>

        {error && (
          <div className="text-red-600 text-sm mb-4">
            {error}
          </div>
        )}

        <div className="flex justify-end">
          <button
            onClick={handleConfirm}
            className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-[#007AFF] hover:bg-[#0066CC] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#007AFF]"
          >
            選択を確定
          </button>
        </div>
      </div>
    </div>
  );
};

export default StoreSelectionModal; 